import { END_RULES_COMBINE } from './endRulesTypes'
import { RESOLVE_TO } from './anchorTypes'

/** Figma copy for earliest_of / latest_of combine toggles (anchors + end rules). */
export const COMBINE_UI_OPTIONS = [
  { key: RESOLVE_TO.earliestOf, text: 'Any anchor is reached' },
  { key: RESOLVE_TO.latestOf, text: 'All anchors are reached' },
]

export const END_RULES_COMBINE_UI_OPTIONS = [
  { key: END_RULES_COMBINE.earliestOf, text: 'Any anchor is reached' },
  { key: END_RULES_COMBINE.latestOf, text: 'All anchors are reached' },
]
